module.exports = __webpack_public_path__ + "media/images/emblems/Montcherand-coat_of_arms-0df535c8fcddae0cc1d4db4840c9ea30.svg";